const body = document.body
const windowHeight = window.innerHeight
const button = document.querySelector('#js-search-toggle')

function search() {
  const hasSearchOverlay = body.classList.contains('has-search-overlay');

  if (!hasSearchOverlay) {
    body.classList.add('has-search-overlay');
    body.style.height = windowHeight + 'px';
    button.classList.add('is-active')
    // console.log('Search clicked');
  } else {
    body.classList.remove('has-search-overlay')
    body.style.height = 'auto'
    button.classList.remove('is-active')
  }
}

function init() {
  if (!button) {
    return
  }

  button.addEventListener('click', () => {
    search()
  })
}

export default init
